import { render, staticRenderFns } from "./todo-create.vue?vue&type=template&id=aa091d12&scoped=true"
import script from "./todo-create.vue?vue&type=script&lang=js"
export * from "./todo-create.vue?vue&type=script&lang=js"
import style0 from "./todo-create.vue?vue&type=style&index=0&id=aa091d12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa091d12",
  null
  
)

export default component.exports